export { default } from './es/icons/FoldersopeningTwoTone';